import React from "react";
import { useTranslation } from "react-i18next";
import { FaInfoCircle } from "react-icons/fa";

const GUIDE_ITEM_KEYS = [
    "guideUnverifiedRemoval",
    "guideReconnectRemoved",
    "guideRetryFailed",
    "guideHoverStatus",
    "guideCompleteSetup",
] as const;

const ConnectedDomainsGuide: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="border rounded-3 bg-info-subtle p-3 mb-4">
            <div className="d-flex align-items-center gap-2 mb-2">
                <FaInfoCircle className="text-info-emphasis" />
                <span className="fw-semibold text-info-emphasis">
                    {t("customDomains.guideTitle")}
                </span>
            </div>
            <ul className="mb-0 ps-4 small text-body">
                {GUIDE_ITEM_KEYS.map((key) => (
                    <li key={key}>{t(`customDomains.${key}`)}</li>
                ))}
            </ul>
        </div>
    );
};

export default ConnectedDomainsGuide;
